import React from "react"
import PropTypes from "prop-types"
import { NavLink, Link } from "react-router-dom"
import { connect } from "react-redux"
import { getTranslate, getActiveLanguage, Translate } from "react-localize-redux"
import { bindActionCreators } from "redux"
import { push } from "connected-react-router"

import { SidebarMenuLinks } from "../../configs/MenuLinks"
import { closeMobileMenu } from "../../redux/modules/MobileMenu"
import AppsIcon from "../../images/icons/app.svg"
import GGPlayLogo from "../../images/logos/ggplay.svg"
import AppStoreLogo from "../../images/logos/appstore.svg"
import { appStoreUrl, ggStoreUrl } from "../../configs"
import appStoreImg from "../../images/icons/app-store.png"
import googlePlayImg from "../../images/icons/google-play.png"

class SideNavBar extends React.Component {
	constructor(props) {
		super(props)

		this.redirect = this.redirect.bind(this)
	}
	renderMenu = ({ path, title, exact, className }, currentLanguage, index) => {
		const url = `/${currentLanguage}${path}`
		return (
			<li
				key={index}
				className="side-bar_list_item"
				onClick={() => this.redirect(url)}>
				<NavLink
					onClick={(e) => e.preventDefault()}
					exact={exact}
					to={url}
					activeClassName="active"
					className={className}>
					<Translate id={title} />
				</NavLink>
			</li>
		)
	}

	redirect = (url) => {
		const { push, closeMenu, isMenuOpen } = this.props

		if (isMenuOpen)
			return Promise.resolve()
				.then(() => closeMenu())
				.then(() =>
					setTimeout(() => {
						push(url)
					}, 250)
				)
		return push(url)
	}

	render() {
		const { currentLanguage, translate } = this.props

		return (
			<div className="side-bar">
				<ul className="side-bar_list mx-1 mx-md-3 my-0 my-lg-5">
					{SidebarMenuLinks.map((path, index) =>
						this.renderMenu(path, currentLanguage, index)
					)}
				</ul>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<div className="side-bar_app_ads">
						<p className="my-2">
							{translate("sidebar.navigation._downloadMobile")}
						</p>
						<img src={AppsIcon} alt="" className="w-75 mb-2" />
						<a
							href={ggStoreUrl}
							target="_blank"
							rel="noopener noreferrer"
							title="Google Play">
							<img
								src={googlePlayImg}
								style={{ width: "100%", height: "auto" }}
								alt=""
								className="my-2 app-store-logo"
							/>
						</a>
						<a
							href={appStoreUrl}
							target="_blank"
							rel="noopener noreferrer"
							title="App Store">
							<img
								src={appStoreImg}
								style={{ width: "100%", height: "auto" }}
								alt=""
								className="my-2 app-store-logo"
							/>
						</a>
					</div>
				</div>
				<div className="side-bar_contact_us">
					<p>
						{translate("sidebar.navigation._havingDifficulties")}
						<br />
						<Link
							className="link link-primary"
							to={`/${currentLanguage}/contact-us`}>
							{translate("sidebar.navigation._contact")}
						</Link>{" "}
						{translate("sidebar.navigation._contactCsv")}
					</p>
				</div>
			</div>
		)
	}
}

SideNavBar.propTypes = {
	location: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	currentLanguage: PropTypes.string.isRequired,
	match: PropTypes.object.isRequired,
}

const mapStateToProps = ({ auth, locale, mobileMenu }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
	isMenuOpen: mobileMenu.isMenuOpen,
})

const mapDispatchToProps = (dispatch) => ({
	closeMenu: bindActionCreators(closeMobileMenu, dispatch),
	push: bindActionCreators(push, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SideNavBar)



// WEBPACK FOOTER //
// ./src/views/layout/SideNavbar.js